/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListControlsResponse {
    getFixupPrototypeFunction() { return ListControlsResponse.fixupPrototype; }

    static newInstance(model: Partial<ListControlsResponse>): ListControlsResponse {
        let obj = Object.assign(new ListControlsResponse(), model);
        ListControlsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListControlsResponse>): ListControlsResponse {
        if (!model) return null;
        return ListControlsResponse.newInstance(<ListControlsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListControlsResponse) {
        if (!obj) return;

        models.ListControlsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListControlsResponse): boolean {
        Object.setPrototypeOf(obj, ListControlsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<string>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
